import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SearchBox from '../components/SearchBox';
import SelectBox from '../components/SelectBox';
import Button from 'react-bootstrap/Button';
import { LocationFilterType, TrackLocationFilterType } from '../utils/Types';
import DatePicker from '../components/KDatePicker';
import { defaultFilter, trackLocationStatusOption } from '../utils/Constant';
import { useAppSelector } from '../store/redux-hooks';
import { trackLocationSelector } from '../features/trackLocationSlice';
import LocationFilter from './LocationFilter';
import moment from 'moment';

interface ITrackLocationFilterProps {
  filterValue?: TrackLocationFilterType;
  isFromAttendance?: boolean;
  onApplyFilters: (trackLocationFilterFilter: TrackLocationFilterType) => void;
}
const TrackLocationFilter: React.FunctionComponent<
  ITrackLocationFilterProps
> = ({ onApplyFilters, filterValue, isFromAttendance }) => {
  const [trackLocationFilter, setTrackLocationFilter] =
    useState<TrackLocationFilterType>(defaultFilter);
  const roleOptions = useAppSelector(trackLocationSelector).roleOptions;
  useEffect(() => {
    if (filterValue && isFromAttendance) {
      setTrackLocationFilter(filterValue);
    }
  }, [
    filterValue,
    filterValue?.employeeId,
    filterValue?.date,
    isFromAttendance,
  ]);
  const onResetFilter = () => {
    onApplyFilters(defaultFilter);
    setTrackLocationFilter(defaultFilter);
  };
  return (
    <div className="border rounded ps-3 pt-2 pb-3 pe-3">
      <Row>
        <Col xs={6} md={2}>
          <SearchBox
            label="Search by Employee Id"
            placeHolder="Ex. 1001001"
            value={trackLocationFilter.employeeId}
            onChange={(e: any) => {
              setTrackLocationFilter({
                ...trackLocationFilter,
                employeeId: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={4}>
          <SearchBox
            label="Search by Employee Name"
            placeHolder="Ex. John Doe"
            value={trackLocationFilter.employeeName}
            onChange={(e: any) => {
              setTrackLocationFilter({
                ...trackLocationFilter,
                employeeName: e.target.value,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Search by Role"
            options={roleOptions}
            className="css-select-bg"
            value={trackLocationFilter.role}
            onChange={(event: any) => {
              setTrackLocationFilter({
                ...trackLocationFilter,
                role: event,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <DatePicker
            label="Date"
            value={trackLocationFilter.date}
            minDate={moment().subtract(89, 'days').toDate()}
            maxDate={moment().toDate()}
            onChange={(date) => {
              setTrackLocationFilter({
                ...trackLocationFilter,
                date: date,
              });
            }}
          />
        </Col>
        <Col xs={6} md={2}>
          <SelectBox
            label="Status"
            options={trackLocationStatusOption}
            className="css-select-bg"
            value={trackLocationFilter.status}
            onChange={(event: any) => {
              setTrackLocationFilter({
                ...trackLocationFilter,
                status: event,
              });
            }}
          />
        </Col>
      </Row>

      <LocationFilter
        filterData={{
          zone: trackLocationFilter.zone,
          state: trackLocationFilter.state,
          district: trackLocationFilter.district,
          city: trackLocationFilter.city,
        }}
        setLocationFilter={(filter: LocationFilterType) => {
          setTrackLocationFilter({
            ...trackLocationFilter,
            zone: filter.zone,
            state: filter.state,
            district: filter.district,
            city: filter.city,
          });
        }}
      />
      <div className="d-flex justify-content-left mt-2">
        <Button
          variant="primary"
          className="cl-btn-primary"
          onClick={() => {
            onApplyFilters(trackLocationFilter);
          }}
        >
          Search
        </Button>
        <Button
          variant="outline-primary"
          className="mx-2 cl-btn-outline-primary"
          onClick={() => {
            onResetFilter();
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default TrackLocationFilter;
